import { cn } from '@/shared/lib/cn';

type SkeletonProps = { variant?: 'block' | 'line'; className?: string; isPulsing?: boolean };

export function Skeleton({ variant = 'block', isPulsing = false, className }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn(
        variant === 'block'
          ? 'h-11 rounded-control bg-surface-3'
          : 'h-2.5 w-3/10 rounded-line bg-surface-4',
        isPulsing && 'motion-safe:animate-shimmer',
        className,
      )}
    />
  );
}
